import {
  logoutUser,
  resetUser as resetAuthUser,
} from "../redux/slices/auth/authSlice";
import {  resetLinkList } from "../redux/slices/gettingLinksList/gettingLinkListSlice";
import { store } from '../redux/store'

export const requestHandler = (request) => {
  const { token } = JSON.parse(localStorage.getItem('user')) || {}
  if (token) request.headers.Authorization = `Bearer ${token}`;
  return request;
};

export const successHandler = (response) => {
  return {
    ...response,
    data: response.data,
  };
};

export const errorHandler = (error) => {
  const { status } = error?.response || {};
  if (status === 401 || status === 403) {
    const { dispatch } = store;
    dispatch(logoutUser());
    dispatch(resetLinkList());
    dispatch(resetAuthUser());
  }
  return Promise.reject(error);
};
